import React from "react";
import "./Modal.scss";
import Modal from "react-bootstrap/Modal";
import img from "../../../assets/img/modal-img.svg";
import { useBaseURL } from "../../contexts/BaseURLContext";

const UnresponsiveModal = ({ show, setShow }) => {
  const baseURL = useBaseURL(); // Get the baseURL from the context
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      <Modal className="custom-modal-wrapper" show={show} size="" onHide={handleClose} centered>
        <Modal.Header closeButton>{/* <Modal.Title>Modal heading</Modal.Title> */}</Modal.Header>
        <Modal.Body>
          <div className="custom-modal-body">
            <img src={img} alt="" className="mb-3" />
            <h1 className="thankyou-modal-title text-dark-blue">Unresponsive</h1>
            <p className="section-subtitle">
              The page you are looking for is not available or <br /> doesn’t belong to this website!
            </p>
            <button className="btn btn-primary border-rad-45 py-3 px-4" onClick={handleClose}>
              Try again
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UnresponsiveModal;
